// Packages
import axios from "axios";
import { SignJWT } from 'jose'

// Cookies
import Cookies from "universal-cookie";
import { DEFAULT_TIMEZONE } from "../../Helpers/Constants";
import { getAPIURL } from "../../Helpers/apiUrl";
import { safeError } from "../../utils/logger";
const cookies = new Cookies();

// Remove the jsonwebtoken import and replace with browser-compatible token generation
// import jwt from "jsonwebtoken";

async function generateTokenJWT() {
  const payload = { iss: process.env.REACT_APP_JWT_ISS };
  const key = process.env.REACT_APP_JWT_KEY;
  try {
    const secret = new TextEncoder().encode(key);

    const token = await   new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setIssuedAt()
      .setExpirationTime('1m')
      .sign(secret);
    
    return token; 
  } catch (error) {
    safeError("Error generating JWT token:", error);
    // Fallback to a simple string if JWT generation fails
    return `${payload.iss}_${Date.now()}`;
  }
}

class Interceptors {
  constructor() {
    // Add a request interceptor

    axios.interceptors.request.use(
      function (config) {
        const accessToken = cookies.get("accessToken");
        if (accessToken) config["headers"]["authorization"] = accessToken;
        // config["headers"]["x-token"] = acc;
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response?.status === 401) {
          cookies.remove("role", { path: "/" });
          cookies.remove("defaultTimezone", { path: "/" });
          cookies.remove("accessToken", { path: "/" });
          window.location.href = "/login";
        }

        return Promise.reject(error);
      }
    );
  }

  async GET(url) {
    let acc = await generateTokenJWT();
    return axios
      .get(getAPIURL(url), { headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE } })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async POST(url, data) {
    let acc = await generateTokenJWT();
    //pass selected store id in header
    let headers = {}
    let requestedstoreid = localStorage.getItem("selectedStore");
    if(data?.selectedStore){
      headers["selectedstoreid"] = data?.selectedStore;
      requestedstoreid = data?.selectedStore;
      delete data?.selectedStore;
    }
    let storetimezone = localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE;
    if (data?.orderTimezone) {
      storetimezone = data?.orderTimezone;
    }
    return axios
      .post(getAPIURL(url), data, {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": storetimezone, ...headers, requestedstoreid},
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async PUT(url, data) {
    let acc = await generateTokenJWT();
    return axios
      .put(getAPIURL(url), data, {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async DELETE(url) {
    let acc = await generateTokenJWT();
    return axios
      .delete(getAPIURL(url), {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async PUT_FILE(url, data) {
    let acc = await generateTokenJWT();
    return axios
      .put(getAPIURL(url), this.jsonToFormData(data), {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  jsonToFormData(data) {
    const formData = new FormData();
    this.buildFormData(formData, data);
    return formData;
  }

  buildFormData(formData, data, parentKey = "") {
    const refThis = this;
    if (
      data &&
      typeof data === "object" &&
      !(data instanceof Date) &&
      !(data instanceof File) &&
      !(data instanceof Blob)
    ) {
      Object.keys(data).forEach((key) => {
        refThis.buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      });
    } else {
      const value = data == null ? "" : data;

      formData.append(parentKey, value);
    }
  }
}

export default Interceptors;

export class NewInterceptors {
  async GET(url) {
    let acc = await generateTokenJWT();
    return axios
      .get(getAPIURL(url), { headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE } })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async POST(url, data) {
  
    let acc = await generateTokenJWT();
    let requestedstoreid = localStorage.getItem("selectedStore");
    let headers = { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE, requestedstoreid};
    if(data?.selectedStore){
      headers["selectedstoreid"] = data?.selectedStore;
      requestedstoreid = data?.selectedStore;
      delete data?.selectedStore;
    }else if(data?.zipcode){
      headers["zipcode"] = data?.zipcode;
      delete data?.zipcode;
    }
    return axios
      .post(getAPIURL(url), data, {
        headers: headers,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async PUT(url, data) {
    let acc = await generateTokenJWT();
    return axios
      .put(getAPIURL(url), data, {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async DELETE(url) {
    let acc = await generateTokenJWT();
    return axios
      .delete(getAPIURL(url), {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async PUT_FILE(url, data) {
    let acc = await generateTokenJWT();
    return axios
      .put(getAPIURL(url), this.jsonToFormData(data), {
        headers: { "x-token": acc , "requestfrom":"admin", "storetimezone": localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  jsonToFormData(data) {
    const formData = new FormData();
    this.buildFormData(formData, data);
    return formData;
  }

  buildFormData(formData, data, parentKey = "") {
    const refThis = this;
    if (
      data &&
      typeof data === "object" &&
      !(data instanceof Date) &&
      !(data instanceof File) &&
      !(data instanceof Blob)
    ) {
      Object.keys(data).forEach((key) => {
        refThis.buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      });
    } else {
      const value = data == null ? "" : data;

      formData.append(parentKey, value);
    }
  }
}
